<div
  *ngIf="isImpersonationUser"
  fxLayout="row"
  class="header impersonate-header"
  data-test-id="hdContainer"
>
  <div fxFlex="40%" fxLayoutAlign="start center" data-test-id="hdLogoContainer">
    <cigna-header-logo
      [ngClass]="isImpersonatorSignin ? 'none' : 'impersonatorNonSigninLogo'"
      [enableToggleSidNav]="true"
      [isImpersonator]="isImpersonationUser"
      [attr.data-test-id]="'hdLogoConmponent'"
    ></cigna-header-logo>
  </div>
  <div *ngIf="isImpersonatorSignin" fxFlex="25%" fxLayoutAlign="start center">
    <span class="impersonator-lan-id">
      Impersonator: <strong>{{ operatorId }}</strong>
      <br />
      Logged In as: <strong>{{ impFirstName }} {{ impLastName }}</strong>
    </span>
  </div>
  <div *ngIf="isImpersonatorSignin" fxFlex="20%" fxLayoutAlign="end center">
    <button
      [routerLink]="'/secure/broker-messages'"
      class="messages-button"
      mat-raised-button
      fxHide.lt-sm
    >
      <cigna-icon class="bell-icon"></cigna-icon>
      <span class="messages-button-text">{{
        'broker.mymessages' | translate
      }}</span>
    </button>
  </div>
  <div
    *ngIf="isImpersonatorSignin || canEnableImpersonatorLogout"
    fxFlex="15%"
    fxLayoutAlign="end center"
  >
    <a class="impersonate-logout" (click)="processLogout(isImpersonatorSignin)"
      >Log Out</a
    >
  </div>
</div>
<div
  fxLayout="row"
  class="header-info header-info-1"
  *ngIf="isImpersonatorSignin"
>
  <div class="header-info-text">
    <cigna-icon
      class="info-circle-outline icon-width"
      type="info-circle-outline"
      mat-button
    ></cigna-icon
    >&nbsp; {{ 'imperonateTool.impStaticHeaderTxt1' | translate }}
    <a class="req-access-ink" (click)="showContactModal()"
      ><strong>{{
        'imperonateTool.impStaticHeaderTxt2' | translate
      }}</strong></a
    >
    {{ 'imperonateTool.impStaticHeaderTxt3' | translate }}
  </div>
</div>
